
import {useState} from 'react';

export type ToggleProps = {
	open: boolean
	toggle: () => void
}

export const useToggle = (initial: boolean): ToggleProps => {
	const [open, setOpen] = useState(initial);
	return {
		open,
		toggle: () => setOpen(!open),
	};
};
